import { $, body } from "@utils/dom";

export const SELECTOR = "[data-site-header]";
//export const SCROLL_MINIMUM = 400;
//export const SCROLL_MINIMUM_CLASSNAME = '--js-min';

class SiteHeader {
  constructor(init = false) {
    this.initialized = false;
    this.el = null;

    //this._hasScrolledAboveThreshold = false;

    //this._onScroll = this._onScroll.bind(this);

    init ? this.init() : null;
  }

  get name() {
    return `SiteHeader`;
  }

  init() {
    this.initialized = true;
    this.el = $(SELECTOR);
    this.initialize();

    this._bindEvents();
  }

  initialize(){
    body.classList.add('--js-site-header-initialized');
  }

  _bindEvents(){
    //this.emitter.on("SiteScroll.scroll", this._onScroll);
  }

  _unbindEvents(){
    //this.emitter.off("SiteScroll.scroll", this._onScroll);
  }

  destroy() {
    this._unbindEvents();

    this.el = null;
    this.initialized = false;
  }

  /*
  _onScroll({ y }) {
    const threshold = y > SCROLL_MINIMUM;

    // if scroll is greater than threshold AND was previously lower than threshold
    if (threshold === true && this._hasScrolledAboveThreshold === false) {
      this._hasScrolledAboveThreshold = true;
      this.el.classList.add(SCROLL_MINIMUM_CLASSNAME);
    }
    // if scroll is lower than threshold AND was previously greater than threshold
    else if (threshold === false && this._hasScrolledAboveThreshold === true) {
      this._hasScrolledAboveThreshold = false;
      this.el.classList.remove(SCROLL_MINIMUM_CLASSNAME);
    }
  }
  */
}

export default SiteHeader;
